import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';
import * as global from '@medlogic/shared/shared-interfaces';

/* Validação customizada: se o controle estiver invisível, não validará.
 * Se estiver visível, checará se é válido através da validação de convencional de required.
 * https://angular.io/docs/ts/latest/cookbook/form-validation.html
 * https://angular.io/docs/ts/latest/cookbook/form-validation.html#!#reactive
 */
export function libVisibleAndRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    // Desconsiderar os controles invisíveis
    if (!control?.enabled) { return null; }
    // Valida se é não informado

    if (new global.GlobalService().IsNullOrEmptyGE(control?.value)) {
      return { libVisibleAndRequired: { name } };
    }
    // Se visível, realizar a validação normalmente
    return Validators.required;
  };
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[libVisibleAndRequired]',
  providers: [{ provide: NG_VALIDATORS, useExisting: VisibleAndRequiredValidatorDirective, multi: true }]
})
export class VisibleAndRequiredValidatorDirective implements Validator, OnChanges {
  @Input() libVisibleAndRequired: string;
  private valFn = Validators.nullValidator;

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes.libVisibleAndRequired;
    if (change) {
      this.valFn = libVisibleAndRequiredValidator();
    } else {
      this.valFn = Validators.nullValidator;
    }
  }

  validate(control: AbstractControl): { [key: string]: any } {
    return this.valFn(control);
  }
}

/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
